/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-imports */
import { useEffect, useState } from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Collapse,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  CheckCircle,
  CreditCard,
  ExpandLess,
  ExpandMore,
  FileCopy,
  GetApp,
  Payment,
  Receipt,
  Settings,
  Smartphone,
  WhatsApp,
} from '@material-ui/icons';

import { rejectionReasons } from '../../constants/rejectionReasons';
import { statusOptions } from '../../constants/statusOptions';
import { useBudget } from '../../context/BudgetContext';
import { PaymentLinkDialog } from './PaymentLinkDialog';
import { useStyles } from './styles';

export default function StatusControls() {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(() => {
    const saved = localStorage.getItem('budgetStatusControlsExpanded');
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    localStorage.setItem('budgetStatusControlsExpanded', JSON.stringify(expanded));
  }, [expanded]);

  const {
    budget: { paymentType, gateway, status, discount, installments, rejectionReasonId },
    gateways,
    downloadingReport,
    generatingPayment,
    confirmingBudget,
    paymentLink,
    setPaymentLink,
    paymentLinkValue,
    setPaymentLinkValue,
    finalBudgetValue,
    setFinalBudgetValue,
    downloadBudgetTemplate,
    updatePaymentType,
    updateGateway,
    updateStatus,
    updateRejectionReason,
    updateDiscount,
    updateInstallments,
    validationErrors,
    validateBudget,
    confirmBudget,
    sendWhatsAppMessage,
    copyWhatsAppMessage,
    downloadServiceOrderReport,
    generatePaymentLink,
  } = useBudget();

  useEffect(() => {
    validateBudget();
  }, [status, rejectionReasonId, finalBudgetValue]);

  const handleCopyPaymentLink = () => {
    if (paymentLink?.paymentLink) {
      navigator.clipboard.writeText(paymentLink.paymentLink);
    }
  };

  const handleClosePaymentDialog = () => {
    setPaymentLink(null);
  };

  const handleActionWithValidation = (action) => {
    if (!validateBudget()) {
      return;
    }
    action();
  };

  const hasValidationErrors = validationErrors.length > 0;

  return (
    <Card className={classes.card}>
      <CardContent>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          style={{ cursor: 'pointer', marginBottom: 16 }}
          onClick={() => setExpanded(!expanded)}
        >
          <Box display='flex' alignItems='center'>
            <Typography variant='h6' className={classes.title}>
              <Settings color='primary' /> Controles do Orçamento{' '}
            </Typography>
          </Box>
          <IconButton size='small'>{expanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
        </Box>

        <Collapse in={expanded}>
          <Box className={classes.section}>
            <Typography variant='subtitle2' className={classes.sectionLabel}>
              Número de Parcelas
            </Typography>
            <FormControl fullWidth variant='outlined' size='small'>
              <InputLabel>Parcelas</InputLabel>
              <Select
                value={installments}
                onChange={(e) => updateInstallments(Number(e.target.value))}
                label='Parcelas'
              >
                {Array.from({ length: 12 }, (_, i) => i + 1).map((num) => (
                  <MenuItem key={num} value={num}>
                    {num}x
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box className={classes.section}>
            <Typography variant='subtitle2' className={classes.sectionLabel}>
              Preço e Tomada de decisão
            </Typography>
            <RadioGroup value={paymentType} onChange={(e) => updatePaymentType(e.target.value)}>
              <FormControlLabel
                value='cartao'
                control={<Radio color='primary' />}
                label={
                  <Box className={classes.radioLabel}>
                    <CreditCard fontSize='small' />
                    <span>Orçamento Por Cartão</span>
                  </Box>
                }
              />
              <FormControlLabel
                value='boleto'
                control={<Radio color='primary' />}
                disabled={installments > 1}
                label={
                  <Box className={classes.radioLabel}>
                    <Receipt fontSize='small' />
                    <span>Orçamento Por Boleto</span>
                    {installments > 1 && (
                      <Typography
                        variant='caption'
                        style={{ color: '#999', marginLeft: 8, fontStyle: 'italic' }}
                      >
                        (disponível apenas para 1x)
                      </Typography>
                    )}
                  </Box>
                }
              />
              <FormControlLabel
                value='pix'
                control={<Radio color='primary' />}
                disabled={installments > 1}
                label={
                  <Box className={classes.radioLabel}>
                    <Smartphone fontSize='small' />
                    <span>Orçamento Por PIX</span>
                    {installments > 1 && (
                      <Typography
                        variant='caption'
                        style={{ color: '#999', marginLeft: 8, fontStyle: 'italic' }}
                      >
                        (disponível apenas para 1x)
                      </Typography>
                    )}
                  </Box>
                }
              />
            </RadioGroup>
          </Box>

          <Box className={classes.section}>
            <FormControl fullWidth variant='outlined'>
              <InputLabel>Gateway de Pagamento</InputLabel>
              <Select
                value={gateway}
                onChange={(e) => updateGateway(e.target.value)}
                label='Gateway de Pagamento'
              >
                <MenuItem value=''>
                  <em>Selecione um gateway</em>
                </MenuItem>
                {gateways.map((gw) => (
                  <MenuItem key={gw.id} value={gw.id}>
                    {gw.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box className={classes.section}>
            <Typography variant='subtitle2' className={classes.sectionLabel}>
              💰 Valor do Link de Pagamento
            </Typography>
            <TextField
              type='number'
              variant='outlined'
              size='small'
              fullWidth
              value={parseFloat(Number(paymentLinkValue || 0).toFixed(2))}
              onChange={(e) => {
                const value = parseFloat(e.target.value) || 0;
                setPaymentLinkValue(value);
              }}
              inputProps={{
                min: 0,
                step: 0.01,
              }}
              helperText='Valor para gerar o link de pagamento (pode ser diferente do total)'
              InputProps={{
                startAdornment: <Typography style={{ marginRight: 8 }}>R$</Typography>,
              }}
            />
          </Box>

          <Box className={classes.section}>
            <Typography variant='subtitle2' className={classes.sectionLabel}>
              Desconto (%)
            </Typography>
            <TextField
              type='number'
              variant='outlined'
              size='small'
              value={discount || 0}
              onChange={(e) => {
                const value = parseFloat(e.target.value) || 0;
                const validValue = Math.min(Math.max(0, value), 100);
                updateDiscount(validValue);
              }}
              inputProps={{
                min: 0,
                max: 100,
                step: 0.01,
              }}
              style={{ width: 100 }}
              helperText='Máximo 100%'
            />
          </Box>

          <Box className={classes.section}>
            <FormControl fullWidth variant='outlined' size='small'>
              <InputLabel>Status do Orçamento</InputLabel>
              <Select
                value={status || ''}
                onChange={(e) => updateStatus(e.target.value)}
                label='Status do Orçamento'
              >
                {statusOptions
                  .filter((option) => option.id !== 'All')
                  .map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.description}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>

          {(status === 3 || status === 7) && (
            <Box className={classes.section}>
              <FormControl fullWidth variant='outlined' size='small' required>
                <InputLabel>Motivo de Recusa *</InputLabel>
                <Select
                  value={rejectionReasonId || ''}
                  onChange={(e) => updateRejectionReason(e.target.value)}
                  label='Motivo de Recusa *'
                  error={!rejectionReasonId}
                >
                  <MenuItem value=''>
                    <em>Selecione um motivo</em>
                  </MenuItem>
                  {rejectionReasons.map((reason) => (
                    <MenuItem key={reason.id} value={reason.id}>
                      {reason.description}
                    </MenuItem>
                  ))}
                </Select>
                {!rejectionReasonId && (
                  <Typography
                    variant='caption'
                    style={{ color: '#f44336', marginTop: 4, marginLeft: 14 }}
                  >
                    Motivo de recusa é obrigatório para este status
                  </Typography>
                )}
              </FormControl>
            </Box>
          )}

          {status === 60 && (
            <Box className={classes.section}>
              <Typography variant='subtitle2' className={classes.sectionLabel}>
                💵 Valor Final do Orçamento *
              </Typography>
              <TextField
                type='number'
                variant='outlined'
                size='small'
                fullWidth
                required
                value={parseFloat(Number(finalBudgetValue || 0).toFixed(2))}
                onChange={(e) => {
                  const value = parseFloat(e.target.value) || 0;
                  setFinalBudgetValue(value);
                }}
                inputProps={{
                  min: 0,
                  step: 0.01,
                }}
                helperText='Valor definitivo do orçamento para status "Pagamento Realizado SC+"'
                error={!finalBudgetValue || finalBudgetValue <= 0}
                InputProps={{
                  startAdornment: <Typography style={{ marginRight: 8 }}>R$</Typography>,
                }}
              />
              {(!finalBudgetValue || finalBudgetValue <= 0) && (
                <Typography
                  variant='caption'
                  style={{ color: '#f44336', marginTop: 4, marginLeft: 14 }}
                >
                  Valor final do orçamento é obrigatório para este status
                </Typography>
              )}
            </Box>
          )}

          {hasValidationErrors && (
            <Box
              style={{
                backgroundColor: '#fff3cd',
                border: '1px solid #ffc107',
                borderRadius: 4,
                padding: 12,
                marginBottom: 16,
              }}
            >
              <Typography variant='subtitle2' style={{ color: '#856404', fontWeight: 600 }}>
                Atenção:
              </Typography>
              {validationErrors.map((error, index) => (
                <Typography key={index} variant='body2' style={{ color: '#856404', marginTop: 4 }}>
                  • {error}
                </Typography>
              ))}
            </Box>
          )}

          <Box marginBottom={2}>
            <Typography
              variant='caption'
              style={{ color: '#666', fontWeight: 600, textTransform: 'uppercase' }}
            >
              Ações Principais
            </Typography>
          </Box>
          <Grid container spacing={2} style={{ marginBottom: 24 }}>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant='contained'
                className={classes.buttonPrimary}
                startIcon={
                  confirmingBudget ? (
                    <CircularProgress size={20} color='inherit' />
                  ) : (
                    <CheckCircle />
                  )
                }
                onClick={confirmBudget}
                disabled={confirmingBudget || hasValidationErrors}
              >
                {confirmingBudget ? 'Confirmando...' : 'Confirmar'}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant='contained'
                style={{
                  backgroundColor: '#4caf50',
                  color: 'white',
                }}
                startIcon={
                  generatingPayment ? <CircularProgress size={20} color='inherit' /> : <Payment />
                }
                onClick={() => handleActionWithValidation(generatePaymentLink)}
                disabled={generatingPayment || !gateway || hasValidationErrors}
              >
                {generatingPayment ? 'Gerando...' : 'Gerar Cobrança'}
              </Button>
            </Grid>
          </Grid>
          <Box marginBottom={2}>
            <Typography
              variant='caption'
              style={{ color: '#666', fontWeight: 600, textTransform: 'uppercase' }}
            >
              Comunicação
            </Typography>
          </Box>
          <Grid container spacing={2} style={{ marginBottom: 24 }}>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant='contained'
                className={classes.buttonWhatsApp}
                startIcon={<WhatsApp />}
                onClick={() => handleActionWithValidation(sendWhatsAppMessage)}
                disabled={hasValidationErrors}
              >
                Enviar
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant='outlined'
                style={{
                  borderColor: '#25D366',
                  color: '#25D366',
                  backgroundColor: 'white',
                }}
                startIcon={<FileCopy />}
                onClick={() => handleActionWithValidation(copyWhatsAppMessage)}
                disabled={hasValidationErrors}
              >
                Copiar Msg
              </Button>
            </Grid>
          </Grid>

          <Box marginBottom={2}>
            <Typography
              variant='caption'
              style={{ color: '#666', fontWeight: 600, textTransform: 'uppercase' }}
            >
              Documentos
            </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant='outlined'
                color='primary'
                startIcon={
                  downloadingReport ? <CircularProgress size={20} color='inherit' /> : <GetApp />
                }
                onClick={downloadServiceOrderReport}
                disabled={downloadingReport}
              >
                Laudo
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant='outlined'
                color='primary'
                startIcon={
                  downloadingReport ? <CircularProgress size={20} color='inherit' /> : <GetApp />
                }
                onClick={() => handleActionWithValidation(downloadBudgetTemplate)}
                disabled={downloadingReport || hasValidationErrors}
              >
                Template
              </Button>
            </Grid>
            {/* <Grid item xs={12}>
              <Button
                fullWidth
                variant='outlined'
                style={{ borderColor: '#9c27b0', color: '#9c27b0' }}
                startIcon={<TrackChanges />}
              >
                Rastreamento
              </Button>
            </Grid> */}
          </Grid>
        </Collapse>
      </CardContent>

      <PaymentLinkDialog
        paymentLink={paymentLink}
        handleClosePaymentDialog={handleClosePaymentDialog}
        handleCopyPaymentLink={handleCopyPaymentLink}
      />
    </Card>
  );
}
